module.exports = __webpack_public_path__ + "img/pimg6.7f2abde1.png";